import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e3b2c8e5726a7a19ea27e3d6d49e6676.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/70"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Over HerStart
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
              Een stichting die zich met hart en ziel inzet voor thuiszittende jongeren 
              en hun weg terug naar het onderwijs en een hoopvolle toekomst.
            </p>
          </div>
        </div>
      </section>

      {/* Missie & Visie */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
                Onze Missie
              </h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-600">
                  <strong className="text-gray-900">HerStart</strong> heeft als missie om thuiszittende meiden en jongeren 
                  te ondersteunen bij hun terugkeer naar het onderwijs. We geloven dat elke jongere het recht heeft 
                  op onderwijs en een betekenisvolle toekomst.
                </p>
                <p className="text-lg text-gray-600">
                  Met onze empathische en deskundige begeleiding creëren we een veilige omgeving waar jongeren 
                  hun motivatie kunnen hervinden, hun zelfvertrouwen kunnen opbouwen en stap voor stap hun weg 
                  terug kunnen vinden naar het onderwijs.
                </p>
                <p className="text-lg text-gray-600">
                  We werken nauw samen met gemeenten, onderwijsinstanties en lokale partners om een netwerk 
                  van ondersteuning te creëren dat jongeren de beste kansen biedt op succes.
                </p>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20young%20people%20in%20a%20supportive%20educational%20environment%2C%20mentor%20working%20with%20teenagers%2C%20bright%20modern%20classroom%20with%20natural%20light%2C%20books%20and%20plants%2C%20inspiring%20and%20hopeful%20atmosphere%2C%20professional%20photography%2C%20warm%20earth%20tones&width=600&height=400&seq=missie-herstart&orientation=landscape"
                alt="Begeleiding van jongeren in onderwijsomgeving"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Visie */}
      <section className="py-20 bg-green-50/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img 
                src="https://readdy.ai/api/search-image?query=Young%20person%20looking%20towards%20bright%20horizon%2C%20growth%20and%20hope%20concept%2C%20sunrise%20or%20sunset%20lighting%2C%20open%20book%20and%20blooming%20flowers%20in%20foreground%2C%20inspirational%20and%20uplifting%20scene%2C%20soft%20warm%20colors%2C%20professional%20photography&width=600&height=400&seq=visie-herstart&orientation=landscape"
                alt="Jongere kijkt naar hoopvolle toekomst"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
            
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
                Onze Visie
              </h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-600">
                  Onze visie is gericht op het <strong className="text-gray-900">herstel van motivatie</strong>, 
                  het opbouwen van <strong className="text-gray-900">zelfvertrouwen</strong> en het creëren van 
                  een <strong className="text-gray-900">duurzaam toekomstperspectief</strong> voor elke jongere 
                  die we begeleiden.
                </p>
                <p className="text-lg text-gray-600">
                  We streven naar een samenleving waarin geen enkele jongere tussen wal en schip valt, 
                  waar iedereen de kans krijgt om te groeien en zich te ontwikkelen tot zijn of haar volle potentieel.
                </p>
                <p className="text-lg text-gray-600">
                  Door onze holistische aanpak en nauwe samenwerking met alle betrokken partijen, 
                  bouwen we aan een toekomst waarin onderwijs toegankelijk en betekenisvol is voor iedereen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Onze Waarden */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Onze Waarden
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Deze kernwaarden vormen de basis van alles wat we doen en hoe we jongeren begeleiden.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Empathie</h3>
              <p className="text-gray-600">
                We luisteren met ons hart en begrijpen de unieke situatie van elke jongere.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Veiligheid</h3>
              <p className="text-gray-600">
                We creëren een veilige omgeving waar jongeren zich geborgen en begrepen voelen.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-3xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Deskundigheid</h3>
              <p className="text-gray-600">
                Onze ervaren professionals bieden bewezen methoden en persoonlijke begeleiding.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Inclusiviteit</h3>
              <p className="text-gray-600">
                We omarmen diversiteit en zorgen ervoor dat elke jongere zich welkom voelt.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Samenwerking */}
      <section className="py-20 bg-orange-50/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Samenwerking is de sleutel
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We geloven in de kracht van samenwerking. Door nauwe banden met verschillende partijen 
              kunnen we jongeren de beste ondersteuning bieden.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-government-line text-2xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Gemeenten</h3>
              <p className="text-gray-600">
                Nauwe samenwerking met lokale overheden voor structurele ondersteuning en beleidsontwikkeling 
                die thuiszittende jongeren ten goede komt.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-school-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Onderwijsinstanties</h3>
              <p className="text-gray-600">
                Directe verbindingen met scholen en onderwijsorganisaties om een soepele terugkeer 
                naar het onderwijs mogelijk te maken.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-community-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Lokale Partners</h3>
              <p className="text-gray-600">
                Samenwerking met zorgverleners, jeugdwerk en andere organisaties voor een compleet 
                netwerk van ondersteuning rondom de jongere.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-green-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Wil je meer weten over onze aanpak?
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-3xl mx-auto">
            Ontdek hoe we jongeren stap voor stap begeleiden van herstel naar groei, 
            en van groei naar een hoopvolle toekomst.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/onze-aanpak"
              className="inline-flex items-center justify-center font-medium bg-white text-green-700 hover:bg-gray-50 px-8 py-4 text-lg rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Onze aanpak
            </Link>
            <Link
              to="/trainingen"
              className="inline-flex items-center justify-center font-medium bg-transparent text-white border-2 border-white hover:bg-white hover:text-green-700 px-8 py-4 text-lg rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Onze trainingen
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
